import { api } from 'shared/api'
import { AiAutomationPlaygroundSchemas } from 'shared/api/requests/aiAutomationPlayground/schemas'

export const AiAutomationPlaygroundApi = {
  startSession: api.account.createPost({
    url: '/aiAutomationPlayground/startSession',
    schemas: AiAutomationPlaygroundSchemas.startSession,
  }),
  startSessionByGoal: api.account.createPost({
    url: '/aiAutomationPlayground/startSessionByGoal',
    schemas: AiAutomationPlaygroundSchemas.startSessionByGoal,
  }),
  sendMessage: api.account.createPost({
    url: '/aiAutomationPlayground/userMessage',
    schemas: AiAutomationPlaygroundSchemas.sendMessage,
  }),
}
